import React, { Children } from 'react'

import classnames from 'classnames'

import css from './Section.css'

type SectionProps = {
  title?: string
  largeTitle?: boolean
  alternateColour?: boolean
  children?: React.ReactNode
  hasPaddingBottom?: boolean
}

const getTitleElement = (title?: string, largeTitle?: boolean) => {
  if (!title) return null
  if (largeTitle) {
    return (
      <h2 className={css.title}>
        <span className={css.titleText}>{title}</span>
      </h2>
    )
  }

  return (
    <h3 className={css.title}>
      <span className={css.titleText}>{title}</span>
    </h3>
  )
}

export const Section: React.FC<SectionProps> = ({
  title = '',
  largeTitle = false,
  alternateColour = false,
  children = null,
  hasPaddingBottom = true,
}) =>
  Children.count(children) ? (
    <div className={classnames(css.wrapper, { [css.alternateBackground]: alternateColour })}>
      <div className={classnames(css.content, { [css.paddingBottom]: hasPaddingBottom })}>
        {getTitleElement(title, largeTitle)}
        {children}
      </div>
    </div>
  ) : null
